export default {
    '1': '잘못된 상품 주문',
    '2': '주문 중복',
    '3': '수령 불가',
    '4': '기타 사유',
    '-连接已建立-': '-연결이 설정되었습니다-',
    ',才可提币': ', 출금 가능',
    '[code]值错误': '[code] 값 오류',
    '[symbol]参数为空': '[symbol] 매개변수가 비어 있습니다',
    homeDownloadtips41: '판매자 앱',
    '不能为空': '비워둘 수 없습니다',
    '不在交易时段': '거래 시간이 아닙니다',
    '不在可提现时间内': '출금 가능 시간이 아닙니다',
    '参数错误': '매개변수 오류',
    '参数异常，消息获取失败': '매개변수 이상, 메시지를 가져오지 못했습니다',
    '操作成功': '작업 성공',
    '操作类型不能小于0': '작업 유형은 0 미만일 수 없습니다',
    '操作类型不是整数': '작업 유형이 정수가 아닙니다',
    '操作类型为空': '작업 유형이 비어 있습니다',
    '产品不存在': '상품이 존재하지 않습니다',
    '产品剩余数量不足': '상품 잔여 수량이 부족합니다',
    '承兑商不存在': '판매상이 존재하지 않습니다',
    '程序错误': '프로그램 오류',
    '持有币种不足': '보유 통화가 부족합니다',
    '充值价值不得大于最大限额': '충전 금액은 최대 한도를 초과할 수 없습니다',
    '充值价值不得小于最小限额': '충전 금액은 최소 한도보다 작을 수 없습니다',
    '充值链错误': '충전 체인 오류',
    '充值数量不能小于等于0': '충전 수량은 0 이하일 수 없습니다',
    '存在不同杠杆的持仓单': '서로 다른 레버리지의 포지션이 있습니다',
    '存在重复的角色名称': '중복된 역할 이름이 있습니다',
    '大于最大采购数量': '최대 구매 수량을 초과합니다',
    '代理层级错误': '대리 등급 오류',
    '待付款的订单无法放行': '결제 대기 주문은 처리할 수 없습니다',
    '当前地址格式错误': '현재 주소 형식 오류',
    '当前订单不为待付款状态，无法取消': '주문이 결제 대기 상태가 아니므로 취소할 수 없습니다',
    '当前还需交易': '추가 거래가 더 필요합니다',
    '当日才可申购': '당일에만 청약 가능합니다',
    '当日可提现次数不足': '당일 출금 횟수가 부족합니다',
    '登陆密码不符合设定': '로그인 비밀번호가 요건에 맞지 않습니다',
    '登陆密码长度不符合设定': '로그인 비밀번호 길이가 요건에 맞지 않습니다',
    '登录过期，请重新登录': '세션이 만료되었습니다. 다시 로그인하세요',
    '登录密码必须6-12位': '로그인 비밀번호는 6-12자여야 합니다',
    '登录密码不能为空': '로그인 비밀번호는 비워둘 수 없습니다',
    '登录失败': '로그인 실패',
    '电话号码已绑定': '전화번호가 이미 연동되어 있습니다',
    '电话号码已绑定其他用户': '전화번호가 이미 다른 사용자에 연동되어 있습니다',
    '订单不存在': '주문이 존재하지 않습니다',
    '订单已取消': '주문이 취소되었습니다',
    '订单已取消，无法放行': '주문이 취소되어 처리할 수 없습니다',
    '订单已完成，无法放行': '주문이 완료되어 처리할 수 없습니다',
    '发现新版本，请升级到最新版本': '새 버전이 있습니다. 최신 버전으로 업데이트하세요',
    '服务器错误': '서버 오류',
    '服务器错误(500)': '서버 오류 (500)',
    '该产品未上架': '이 상품은 등록되지 않았습니다',
    '该产品已上市，无法购买': '이 상품은 이미 상장되어 구매할 수 없습니다',
    '该订单已取消': '이 주문은 취소되었습니다',
    '该广告剩余数量不足': '이 광고의 잔여 수량이 부족합니다',
    '该基金尚未开放购买': '이 펀드는 아직 구매할 수 없습니다',
    '该基金尚已封闭': '이 펀드는 이미 마감되었습니다',
    '该邮箱已被订阅': '이 이메일은 이미 구독되어 있습니다',
    '格式有误:充值金额不能小于1(包含俩位小数)': '형식 오류: 충전 금액은 1 미만일 수 없습니다 (소수점 2자리 포함)',
    '跟单倍数输入错误': '카피 트레이딩 배수 입력 오류',
    '跟单参数输入错误': '카피 트레이딩 매개변수 입력 오류',
    '更新提醒': '업데이트 알림',
    '工作地址不能为空': '직장 주소는 비워둘 수 없습니다',
    '购买矿机时间不得低于托管订单剩余时间': '채굴기 구매 기간은 호스팅 주문 잔여 시간보다 짧을 수 없습니다',
    '广告不存在': '광고가 존재하지 않습니다',
    '广告已下架': '광고가 내려졌습니다',
    '基金剩余购买金额不足': '펀드 잔여 구매 금액이 부족합니다',
    '家庭地址不能为空': '집 주소는 비워둘 수 없습니다',
    '交易员不存在': '트레이더가 존재하지 않습니다',
    '交易员不能跟随自己': '트레이더는 자신을 팔로우할 수 없습니다',
    '交易员跟随人数已满': '트레이더의 팔로워 수가 가득 찼습니다',
    '交易员未开启带单': '트레이더가 카피 트레이딩을 활성화하지 않았습니다',
    '交易员无法跟随另一个交易员': '트레이더는 다른 트레이더를 팔로우할 수 없습니다',
    '角色被用户关联，不可删除': '역할이 사용자와 연결되어 있어 삭제할 수 없습니다',
    '角色不存在': '역할이 존재하지 않습니다',
    '金额不在购买区间': '금액이 구매 범위에 없습니다',
    '金额错误': '금액 오류',
    '旧密码不能为空': '이전 비밀번호는 비워둘 수 없습니다',
    '旧密码不正确': '이전 비밀번호가 올바르지 않습니다',
    '可平仓合约张数不足': '청산 가능한 계약 수가 부족합니다',
    '矿机不存在': '채굴기가 존재하지 않습니다',
    '矿机未解锁，无法购买': '채굴기가 잠금 해제되지 않아 구매할 수 없습니다',
    '历史基金无法购买': '과거 펀드는 구매할 수 없습니다',
    '连续输入错误三次，请3分钟后再试': '연속 3회 잘못 입력했습니다. 3분 후 다시 시도하세요',
    '领取成功': '수령 완료',
    '买入金额需要在区间内': '매수 금액은 범위 내여야 합니다',
    '卖方无法取消该订单': '판매자는 이 주문을 취소할 수 없습니다',
    '没有找到用户': '사용자를 찾을 수 없습니다',
    verificationCode: '인증 코드',
    pleaseEnterVerificationCode: '인증 코드를 입력하세요',
    pleaseEnterUsername: '사용자 이름을 입력하세요',
    username: '사용자 이름',
    getVerificationCode: '코드 받기',
    tryAgainLater: '초 후 다시 시도',
    '密码必须6-12位': '비밀번호는 6-12자여야 합니다',
    '密码不能为空': '비밀번호는 비워둘 수 없습니다',
    '密码不正确': '비밀번호가 올바르지 않습니다',
    '您当前可分配额度不足': '현재 할당 가능 한도가 부족합니다',
    '您没有符合条件的收款方式': '적합한 수금 방법이 없습니다',
    '您已存在订单': '이미 주문이 있습니다',
    '您已购买过体验矿机,不得重复购买': '이미 체험 채굴기를 구매하여 중복 구매할 수 없습니다',
    '亲属地址不能为空': '친족 주소는 비워둘 수 없습니다',
    '亲属电话不能为空': '친족 전화번호는 비워둘 수 없습니다',
    '亲属关系不能为空': '친족 관계는 비워둘 수 없습니다',
    '亲属姓名不能为空': '친족 이름은 비워둘 수 없습니다',
    '请检查网络连接': '네트워크 연결을 확인하세요',
    '请上传图片': '이미지를 업로드하세요',
    '请稍后再试': '잠시 후 다시 시도하세요',
    '请稍后重试': '잠시 후 다시 시도하세요',
    '请输入充值币种': '충전 통화를 입력하세요',
    '请输入内容': '내용을 입력하세요',
    '请输入搜索关键字': '검색 키워드를 입력하세요',
    '请输入正确的货币数量': '올바른 통화 수량을 입력하세요',
    '请输入正确的金额': '올바른 금액을 입력하세요',
    '请输入正确的数量': '올바른 수량을 입력하세요',
    '请输入正确的质押金额': '올바른 스테이킹 금액을 입력하세요',
    '请输入正确的质押天数': '올바른 스테이킹 일수를 입력하세요',
    '请填写正确的电话号码': '올바른 전화번호를 입력하세요',
    '请填写正确的验证码': '올바른 인증 코드를 입력하세요',
    '请填写正确的邮箱地址': '올바른 이메일 주소를 입력하세요',
    '请先绑定谷歌验证器': '먼저 Google Authenticator를 연동하세요',
    '请先添加收款方式': '먼저 수금 방법을 추가하세요',
    '请先通过高级认证': '먼저 고급 인증을 완료하세요',
    '请选择买卖方式': '매매 방식을 선택하세요',
    '请选择正确的币种': '올바른 통화를 선택하세요',
    '请重新登录': '다시 로그인하세요',
    '渠道未开通': '채널이 개통되지 않았습니다',
    '取消': '취소',
    '确认': '확인',
    '申购数量错误': '청약 수량 오류',
    '申请成功': '신청 성공',
    '身份证已实名过!': '신분증이 이미 실명 인증되었습니다!',
    '审核已通过': '심사 통과',
    '审核中': '심사 중',
    '实名认证未通过，无法进行高级认证': '실명 인증이 통과되지 않아 고급 인증을 진행할 수 없습니다',
    '收款方输入错误': '수취인 입력 오류',
    '授权状态未成功': '인증 상태가 성공하지 못했습니다',
    '赎回状态异常': '환매 상태 이상',
    '所选汇率不存在': '선택한 환율이 존재하지 않습니다',
    '提币数量不能小于等于0': '출금 수량은 0 이하일 수 없습니다',
    '提交失败': '제출 실패',
    '提交失败，当前有未处理订单': '제출 실패, 처리되지 않은 주문이 있습니다',
    '提示': '안내',
    '提现不得大于限额': '출금은 한도를 초과할 수 없습니다',
    '提现不得小于限额': '출금은 한도보다 작을 수 없습니다',
    '图片不得大于10M': '이미지는 10MB를 초과할 수 없습니다',
    '图片不得大于2M': '이미지는 2MB를 초과할 수 없습니다',
    '图片大小不能超过2M！': '이미지 크기는 2MB를 초과할 수 없습니다!',
    '图片上传失败': '이미지 업로드 실패',
    '推荐码不正确': '추천 코드가 올바르지 않습니다',
    '推荐人无权限推荐': '추천인에게 추천 권한이 없습니다',
    '委托数量(张)必填': '주문 수량(계약)은 필수입니다',
    '委托数量(张)不能小于等于0': '주문 수량(계약)은 0 이하일 수 없습니다',
    '未绑定谷歌验证器': 'Google Authenticator가 연동되지 않았습니다',
    '未绑定手机号': '전화번호가 연동되지 않았습니다',
    '未绑定邮箱': '이메일이 연동되지 않았습니다',
    '未发现授权记录': '인증 기록을 찾을 수 없습니다',
    '未实名认证，是否认证？': '실명 인증되지 않았습니다. 인증하시겠습니까?',
    '未授权访问': '권한 없는 접근',
    '未找到符合条件的匹配订单': '조건에 맞는 주문을 찾을 수 없습니다',
    '未找到匹配的收益记录': '일치하는 수익 기록을 찾을 수 없습니다',
    myComment: '내 평가',
    myPoint: '내 포인트',
    accountInfo: '계정 정보',
    myBalance: '내 잔액',
    myCoupon: '내 쿠폰',
    unused: '미사용',
    used: '사용됨',
    expired: '만료됨',
    expires: '유효기간',
    minSpend: '이상',
    availableBalance: '사용 가능 잔액',
    personalDeposit: '잔액',
    useDepositBalance: '잔액으로 차감',
    depositDeduct: '잔액 차감',
    useMaxDeposit: '전액 차감',
    balanceHistory: '잔액 내역',
    recordCount: '총 {count}건',
    depositType: '거래 유형',
    balanceAfter: '잔여 금액',
    depositTypeRecharge: '잔액 충전',
    depositTypeAdjustment: '잔액 조정',
    depositTypeOrderPayment: '주문 결제',
    depositTypeOrderRefunds: '주문 환불',
    depositTypeDistributionCommission: '분배 수수료',
    depositTypeDistributionWithdrawal: '분배 출금',
    depositTypeOther: '기타',
    income: '수입',
    expense: '지출',
    description: '설명',
    myFootprint: '내 발자취',
    '无权限': '권한 없음',
    '无效的UID': '유효하지 않은 UID',
    '系统参数错误': '시스템 매개변수 오류',
    '系统存在相同[系统登录名]！': '시스템에 동일한 [로그인 이름]이 있습니다!',
    '系统错误，请稍后重试': '시스템 오류, 잠시 후 다시 시도하세요',
    '下单不能小于最小金额限制': '주문은 최소 금액보다 작을 수 없습니다',
    '校验IP不合法': '검증 IP가 유효하지 않습니다',
    '新密码不能为空': '새 비밀번호는 비워둘 수 없습니다',
    '新密码不一致': '새 비밀번호가 일치하지 않습니다',
    '新密码确认不能为空': '새 비밀번호 확인은 비워둘 수 없습니다',
    '行情获取异常，稍后再试': '시세 데이터를 가져오지 못했습니다. 잠시 후 다시 시도하세요',
    '验证类型不能为空': '인증 유형은 비워둘 수 없습니다',
    '验证码不能为空': '인증 코드는 비워둘 수 없습니다',
    '验证码不正确': '인증 코드가 올바르지 않습니다',
    '验证码错误': '인증 코드 오류',
    '页码不能小于等于0': '페이지 번호는 0 이하일 수 없습니다',
    '页码不是整数': '페이지 번호가 정수가 아닙니다',
    '已领取': '수령 완료',
    '用户不存在': '사용자가 존재하지 않습니다',
    '用户名必须由数字和英文字母组成': '사용자 이름은 숫자와 라틴 문자로 구성되어야 합니다',
    '用户名不存在': '사용자 이름이 존재하지 않습니다',
    '用户名不符合设定': '사용자 이름이 요건에 맞지 않습니다',
    '用户名不能为空': '사용자 이름은 비워둘 수 없습니다',
    '用户名参数为空': '사용자 이름 매개변수가 비어 있습니다',
    '用户名重复': '사용자 이름 중복',
    '用户剩余数量不足': '사용자 잔여 수량이 부족합니다',
    '用户已跟随交易员': '사용자가 이미 트레이더를 팔로우하고 있습니다',
    '邮箱已绑定': '이메일이 이미 연동되어 있습니다',
    '邮箱已绑定其他用户': '이메일이 이미 다른 사용자에 연동되어 있습니다',
    '余额不足': '잔액 부족',
    shop_order_insufficientBalance: '계정 잔액이 부족합니다',
    '帐户异常需要进行C3认证，请联系在线客服。': '계정 이상으로 C3 인증이 필요합니다. 온라인 고객센터에 문의하세요.',
    '找不到用户': '사용자를 찾을 수 없습니다',
    flashSale: '플래시 세일',
    groupBuy: '공동구매',
    groupBuying: '공동구매',
    couponCenter: '쿠폰 센터',
    pointMall: '포인트몰',
    liveList: '라이브',
    endsIn: '종료까지',
    soldOut: '판매됨',
    people: '명',
    joined: '참여함',
    startGroup: '공동구매 시작',
    getCoupon: '받기',
    '直线关系，不能修改推荐': '직계 관계, 추천을 수정할 수 없습니다',
    '重复提交': '중복 제출',
    '转账币种不能为空': '이체 통화는 비워둘 수 없습니다',
    '转账数量不能小于等于0': '이체 수량은 0 이하일 수 없습니다',
    '状态不能小于0': '상태는 0 미만일 수 없습니다',
    '状态不是整数': '상태가 정수가 아닙니다',
    '资金密码必须6-12位': '자금 비밀번호는 6-12자여야 합니다',
    '资金密码不符合设定': '자금 비밀번호가 요건에 맞지 않습니다',
    '资金密码不能为空': '자금 비밀번호는 비워둘 수 없습니다',
    '资金密码错误': '자금 비밀번호 오류',
    '资金密码长度不符合设定': '자금 비밀번호 길이가 요건에 맞지 않습니다',
    'UID不能为空': 'UID는 비워둘 수 없습니다',
    required: '필수 항목입니다',
    nickname: '닉네임',
    enterNickname: '닉네임을 입력하세요',
    gender: '성별',
    male: '남성',
    female: '여성',
    secret: '비공개',
    birthday: '생일',
    selectDate: '날짜 선택',
  cancelOrderMap: {
    0: "나는 그것을 원하지 않는다.",
    1: "제품을 잘못 놓음",
    2: "중복 주문",
    3: "수신 실패",
    4: "다른 이유들",
  },
  "获取验证码": "인증 코드 받기",
  "请输入验证码": "인증 코드를 입력하십시오",
  "验证码": "인증 코드",
  "发送": "보내기",
  "已发送，请注意查收": "보냈습니다, 주의 하십시오",
  "电商批发商场": "전자 상거래 도매 시장",
  "当前余额": "현재 잔액",
  "请输入完整的支付密码!" : "완전한 지불 비밀번호를 입력하십시오!",
  "用户未发表评论": "사용자가 댓글을 달지 않았습니다.",
  "订单": "주문하다",
  "备注": "비고",
  "下单成功，等待付款": "주문 완료, 결제 대기 중",
  "下单成功，付款成功": "주문 성공, 결제 성공",
  "已发货，正在运输中": "배송 중, 운송 중",
  "订单已取消，原因:手动发起取消订单": "주문이 취소되었습니다. 이유: 수동으로 주문을 취소하십시오.",
  "订单已取消，原因:超时自动取消订单": "주문이 취소되었습니다. 이유: 시간 초과 시 주문이 자동으로 취소됩니다.",
  "商家已确认，已进入备货状态": "판매자가 확인되어 재고 상태에 진입했습니다.",
  "系统发货成功": "시스템 전달 성공",
  "订单已签收": "주문 접수",
  "发起退款申请": "환불 요청 시작",
  "退款成功": "환불 성공",
  "退款失败": "환불 실패",
  "订单退款成功": "주문 환불 성공",
  "订单退款失败": "주문 환불 실패",
  "系统默认好评": "시스템은 기본적으로 호의적인 리뷰로 설정됩니다.",
  "请输入关键字搜索": "검색할 키워드를 입력하세요",
  "猜你喜欢": "당신이 그것을 좋아 추측",
  "订单已完成": "주문이 완료되었습니다",
  "热销推荐": "뜨거운 판매 추천",
  "头像选择": "아바타 선택",
  "修改头像": "아바타 수정",
  subOrder: "주문을 제출",
  "mailboxCheck": "정확한 이메일 주소를 입력해주세요",
  "switchLang": "보려면 다른 언어로 전환하십시오",
  "myCart": "내 장바구니",
  "notQua": "자격 조건이 충족되지 않습니다.",
  "noSmaller": "적용 금액은 다음보다 작을 수 없습니다.",
  "nomax": "최대 신청 금액은 초과할 수 없습니다.",
  "evaluationUploading": "아직 업로드 중인 사진이 있습니다. 나중에 다시 시도 해주십시오",
  "evaluateInput": "사진으로 검토",
  "moneyOrderStatus": "주문 상태",
  "coinBlock": "통화 계약",
  "dealing": "과정에서",
  "dealSuccess": "성공적인",
  "dealFail": "실패하다",
  "payCertificate": "결제 증명서",
  "handleFee": "서비스 비용",
  "highOpinion": "좋은 리뷰",
  "mediumOpinion": "중간 리뷰",
  "lowOpinion": "나쁜 리뷰",
  "hasImage": "사진과 함께",
  "rechargeMethod": "충전 모드",
  "scanAndDown": "QR 코드 스캔 앱 다운로드",
  "receivedAddress": "수령 주소",
  "ActualLedger": "실제 영수증",
  "view": "보다",
  "withdrawNum": "현금 인출 수량",
  "rechargeNum": "충전량",
  "date": "날짜",
  "walletHistory": "지갑 내역",
  "accountBalance": "계정 잔액",
  "accountReview": "계정 개요",
  "rated": "검토됨",
  "receiver": "수화기",
  "orderStatus": "상태",
  "orderTime": "시간",
  "tax": "과세",
  "discount": "할인",
  "productInfo": "제품 정보",
  "paramError": "매개변수 오류",
  "orderInfo": "주문 정보",
  "rebuy": "한 번 더 주문",
  "pleaseCorrectAddress": "정확한 현금인출 주소를 입력해주세요",
  "pleaseInputCorrectNumber": "0보다 큰 숫자를 입력하세요.",
  "vcodePass": "확인이 통과되었습니다!",
  "vcodeFail": "인증 실패. 다시 시도하십시오",
  "uploading": "업로드 중...",
  "uploadSuccess": "업로드 성공",
  "uploadError": "업로드에 실패했습니다. 다시 시도해 주세요",
  "registerSuccess": "등록 성공",
  "pleaseSetMobileNumber": "전화번호를 설정해주세요",
  "unSelectedProduct": "제품을 선택하지 않았습니다.",
  "loginSuccess": "로그인 성공",
  "pleaseSetAreaCode": "검색할 국가명과 지역번호를 입력하세요.",
  "login": "로그인",
  "register": "등록",
  "logout": "출구",
  "noData": "데이터가 없습니다",
  "search": "찾다",
  "historySearch": "과거 검색",
  "empty": "비어 있는",
  "home": "홈페이지",
  "favorableRate": "좋은 리뷰 비율",
  "classification": "범주",
  "searchTips": "소스검색/제품/공급사/주문",
  "dailyNewArrival": "일일 신상품 등재",
  "more": "더",
  "recommend": "추천",
  "recommendedProducts": "추천 제품",
  "recommendedStore": "추천 매장",
  "buyNow": "지금 구입",
  "addCart": "장바구니에 담기",
  "complex": "통합",
  "price": "가격",
  "retailPrice": "소매 가격",
  "originPrice": "원래 가격",
  "service": "고객 서비스",
  "collect": "즐겨찾기",
  "sold": "판매량",
  "pageviews": "브라우징 양",
  "quantity": "수량",
  "freight": "뱃짐",
  "shipping": "배송",
  "ship": "보트",
  "buyTips": "주문 후 24시간 이내에 배송해 드립니다. 다음 주문은 물류 관리 하에 배송이 지연될 수 있습니다. 물류 정보에 주의를 기울이거나 고객 서비스에 문의하십시오.",
  "totalPrice": "총 가격",
  "addCartMessage": "장바구니에 성공적으로 추가되었습니다.",
  "addCartMessageFaild": "상품이 이미 장바구니에 있습니다.",
  "myAccount": "내 qccount",
  "buyHistory": "구매기록",
  "wishlist": "좋아하는 제품",
  "trackOrder": "주문하다",
  "account": "계정:",
  "sellerZone": "가맹점 지역",
  "beSeller": "상인이 되십시오",
  "sellerPanelLogin": "판매자 로그인",
  "footTip": "© 저작권 {name} Ltd 2024",
  "footTips": "{name} Limited는 신용 중개인(713206)으로서 FCA의 승인 및 규제를 받으며 대출 기관인 Home Retail Group CardServices Limited와 {name} 금융 서비스로 독점적으로 거래합니다. {name} 금융 서비스는 신용 제공(716148)을 위해 Financial Conduct Authority의 승인 및 규제를 받습니다. Home Retail GroupCard Services Limited는 영국(04007072)(Avebury, 489-499 Avebury Boulevard, Milton Keynes, United Kingdom)에 등록되어 있습니다. MK9 2NW.",
  "item": "기사",
  "checkout": "주문",
  "productDescription": "제품 설명",
  "userEvaluation": "사용자 후기",
  "AllProducts": "모든 상품",
  "followers": "따르다",
  "sales": "판매량",
  "visitStore": "매장 방문",
  "authentic": "100% 정품",
  "dayReturns7": "7일 반품",
  "shippingDiscounts": "운임할인",
  "safePayment": "보안 결제",
  "followed": "팔로우",
  "dashboard": "계기판",
  "myOrder": "내 주문",
  "setUp": "설정",
  "successTips": "성공적인",
  "copySuccess": "복제 성공",
  "balance": "잔액(USDT)",
  "sort": "유형",
  "commodity": "제품",
  "browse": "판매량",
  "recharge": "재충전",
  "commodityCollection": "제품 컬렉션",
  "withdraw": "현금 인출",
  "defaultAddress": "기본 주소",
  "addNewAddress": "새 주소 추가",
  "withdrawRecord": "현금 인출 기록",
  "serialNumber": "주문번호",
  "time": "시간",
  "amount": "양",
  "processing": "과정에서",
  "fail": "실패하다",
  "blockchainNetwork": "블록체인 네트워크",
  "records": "기록",
  "withdrawAddress": "현금 인출 주소",
  "withdrawInputTips": "출금주소를 입력해주세요",
  "copy": "복제",
  "enterTips": "들어 오세요",
  "actualAccount": "실제 계정",
  "handlingFee": "서비스 비용",
  "confirm": "영수증 확인",
  "previous": "이전 단계",
  "pleaseEnterAddress": "주소를 입력하세요.",
  "pleaseEnterQuantity": "수량을 입력하세요",
  "withdrawSuccess": "성공적으로 제출된 주문",
  "saveQr": "QR 코드 저장",
  "pleaseEnterAmount": "충전금액을 입력해주세요",
  "expectedArrival": "예상 도착",
  "currentRate": "현재 환율",
  "uploadTips": "결제 증명(결제 내역 스크린샷 업로드)",
  "clickUpload": "업로드하려면 클릭하세요.",
  "uploadPhoto": "사진을 올려주세요",
  "rechargeSuccessful": "충전 성공",
  "rechargeTips": "\"충전 프롬프트: \"\"실제 이체 금액을 사실대로 입력하십시오. 그렇지 않으면 시스템이 승인을 통과하지 못하고 충전 진행에 영향을 미칠 수 있습니다.\"",
  "rechargeRecord": "충전 기록",
  "all": "모두",
  "pending": "지불됩니다",
  "cancelled": "취소 된",
  "delivered": "배송 예정",
  "confirmed": "확인됨",
  "receipt": "수신 예정",
  "harvested": "받았다",
  "comment": "검토 예정",
  "refund": "환불/판매 후",
  "cancelOrder": "주문 취소",
  "cancelReason": "취소 이유",
  "cancelOrderTitle": "주문 취소 사유를 선택해주세요.",
  "returnOrderTitle": "반품사유를 선택해주세요",
  "refundInstructions": "환불 안내",
  "returnDetailTips": "상품에 대한 리뷰를 부탁드립니다",
  "cancel": "주문 취소",
  "cancelOrder1": "제품을 받지 못함",
  "cancelOrder2": "싫어, 원하지 않아",
  "cancelOrder3": "판매자가 잘못된 상품을 배송했습니다",
  "cancelOrder4": "가짜 브랜드",
  "cancelOrder5": "적은 배송, 놓친 배송",
  "cancelOrder6": "손상된 제품 수령",
  "cancelOrder7": "품질 문제가 있습니다",
  "cancelOrder8": "판매자와 환불 협상",
  "cancelOrder9": "다른 이유들",
  "cancelOrderSuccess": "주문이 취소되었습니다.",
  "returnOrderSuccess": "성공적으로 제출",
  "orderName": "이름",
  "orderEmail": "이메일",
  "orderAddress": "주소",
  "orderNation": "국가",
  "orderState": "상태",
  "orderCity": "도시",
  "orderPostCode": "우편 번호",
  "orderAmount": "수량",
  "orderPrefix": "총 주문",
  "orderFee": "구실",
  "orderSpecification": "사양",
  "orderCommodity": "제품",
  "orderQuantity": "수량",
  "orderUnitprice": "단가",
  "orderFreight": "뱃짐",
  "orderTax": "세",
  "orderTotal": "총",
  "PaymentOrder": "결제 주문",
  "Evaluate": "검토",
  "CancelOrder": "주문 취소",
  "RemindShip": "배송 알림",
  "Refund": "환불하다",
  "Submitareview": "리뷰 제출",
  "Information": "정보",
  "wrongPassword": "비밀번호 오류 3회 이상. 내일 다시 시도해 주세요.",
  "Operate": "작업",
  "Item": "항목",
  "From": "에서",
  "hint": "팁",
  "CheckDetails": "세부 정보보기",
  "Payment": "지불",
  "Cancel": "취소",
  "refundSuccessfully": "환불 성공",
  "pendingPayment": "지불됩니다",
  "pay": "지불",
  "LoginPassword": "로그인 비밀번호",
  "sure": "물론",
  "shippingAddress": "받는 주소",
  "transactionPassword": "거래 비밀번호",
  "markDefaultAddress": "기본 배송 주소로 표시",
  "edit": "편집자",
  "delete": "삭제",
  "Opt": "선택하다",
  "piece": "PC",
  "orderDetails": "주문 내역",
  "shopCollection": "즐겨찾기에 매장 추가",
  "addAddress": "새 주소 추가",
  "signUp": "등록",
  "loginTips": "이미 계정이 있습니까?",
  "loginIn": "로그인",
  "mobile": "전화 번호",
  '购物车还没有商品': "장바구니에 제품이 없습니다.",
  '去购物': "쇼핑하러 가기",
  "modifyAddress": "주소 수정",
  "desc": "기본 주소로 설정",
  "keep": "유지하다",
  "onlineService": "온라인 서비스",
  "send": "보내다",
  "EsShop": "온라인 매장",
  "desc3": "거래 비밀번호 입력",
  "desc4": "거래 비밀번호를 입력하세요",
  "desc6": "거래 비밀번호를 다시 입력하세요",
  "setUpPayPaw": "거래 비밀번호 설정",
  "setSuccess": "설정 성공",
  "confirmPayPaw": "거래 비밀번호 확인",
  "paymentSuccessful": "결제 성공",
  "desc5": "잘못된 배송 주소? 연락하다",
  "customeService": "온라인 고객 서비스",
  "BackHome": "홈페이지로 돌아 가기",
  "Checkorder": "주문보기",
  "ForgotPassword": "비밀번호를 잊으셨나요?",
  "signIn": "로그인",
  "noAccount": "계좌번호가 없나요?",
  "pleaseEnterAccount": "계좌번호를 입력해주세요",
  "pleaseEnterPassword": "비밀번호를 입력 해주세요",
  "password": "비밀번호",
  "mobilePhone": "전화 번호",
  "pleaseEnterPhoneNumer": "전화번호를 설정해주세요",
  "setPassword": "암호를 설정하세요",
  "noDataFound": "데이터가 없습니다",
  "searchCountry": "검색할 국가명과 지역번호를 입력하세요.",
  "pleaseEnterEmail": "메일박스를 설정해주세요",
  "invitationCode": "초대 코드",
  "plaeseEnterInvitaionCode": "초대코드를 설정해주세요",
  "pleaseSetLoginPassword": "로그인 비밀번호를 설정해주세요",
  "selectDeliveryAddress": "배송지 선택",
  "totalOf": "총",
  "items": "안건",
  "orderSummary": "주문 요약",
  "paymentMethod": "지불 방법",
  "Balance": "균형",
  "payPal": "페이팔",
  "notOpen": "해당 지역에서는 아직 이 결제 수단을 사용할 수 없습니다.",
  "mastercard": "마스터 카드",
  "additional": "추가의",
  "handlingfee": "봉사료 필요",
  "goodsNumber": "제품 수량",
  "deliveryFee": "화물",
  "totalNum": "총",
  "new": "새로운",
  "oldPassword": "기존 비밀번호",
  "pleaseEnterOldPassword": "기존 비밀번호를 입력해주세요",
  "newPassword": "새 비밀번호",
  "plaseeEnterNewPassword": "새로운 비밀번호를 입력해주세요",
  "confirmPassword": "비밀번호 확인",
  "plaseeENterConfirmPassword": "확인 비밀번호를 입력해주세요",
  "twoPawword": "두 개의 비밀번호가 동일하지 않습니다.",
  "rechargeAddress": "충전 주소",
  "plaseEnterRechargeAddress": "충전주소를 입력해주세요",
  "userCenter": "개인 센터",
  "merchantSettled": "가맹점 입장",
  "upNew": "새 상품이 등록됨",
  "balanceNot": "균형이 충분하지 않습니다. 재충전하십시오.",
  "NoProductSelected": "아직 선택되지 않은 제품",
  "ShippingAddressNotSet": "배송 주소가 설정되지 않음",
  "consigneeName": "수취인 이름",
  "email": "이메일:",
  "areaCode": "국제 지역 번호",
  "phoneNumber": "전화 번호",
  "nation": "국가",
  "state": "지방/주/주",
  "city": "도시",
  "postCode": "우편 번호",
  "address": "자세한 주소",
  "addAddressOrModifyAddress": "새 주소 추가/주소 수정",
  "setAsTheDefaultAddress": "기본 주소로 설정",
  "proceed": "계속하다",
  "btnSure": "확인하다",
  "pleaseInput": "들어 오세요",
  "allProduct": "모든 상품",
  "myCommodityCollection": "좋아하는 제품",
  "myFollowedShops": "스토어 팔로우",
  "mySold": "판매된",
  "myPageviews": "브라우징 양",
  "myPraiseRate": "좋은 리뷰 비율",
  "myUnfollow": "언팔로우",
  "inputNum": "숫자",
  "inpuEmailErro": "정확한 이메일 주소를 입력해주세요",
  "goodsShip": "선적",
  "goodsShipTips": "제품은 주문 후 24시간 이내에 배송됩니다. 다음 주문에 대한 물류 통제가 있을 경우 주문이 지연될 수 있습니다. 주문의 물류 정보에 주의를 기울이거나 고객 서비스에 문의하십시오.",
  "goodsFreight": "화물",
  "goodsFreeShipping": "무료로",
  "goodsFreightTips1": "1. 해외 상품 운임 구성 : 운임=발송비+장거리운임+택배비",
  "goodsFreightTips2": "2. 우송료 조건이 충족되지 않은 경우 실제 조건에 따라 운임이 부과됩니다.",
  "goodsFreightTips3": "3. 최종 해석권은 플랫폼에 있습니다.",
  "pleaseValidPostCode": "4자리 이상 입력해주세요",
  "pleaseValidEmail": "정확한 이메일 주소를 입력해주세요",
  "pleaseValidPhone": "정확한 전화번호를 입력해주세요",
  "productAvailable": "이 제품은 게시 중단되었습니다",
  "validatorMaxNumber": "금액이 한도를 초과합니다.",
  "validatorRequire": "필수 항목은 null일 수 없습니다.",
  "validatorPhone": "정확한 전화번호를 입력해주세요",
  "validatorEmail": "올바른 이메일 형식을 입력하세요.",
  "加值": "충전",
  "银行卡": "은행 카드",
  "平台人工发起退款": "플랫폼 인공 발행 환불",
  "提领": "인출",
  "联系商家": "연락처 판매자",
  "validatorPassword": "비밀번호는 6~12자리 숫자 또는 영문으로 구성되어 있습니다.(특수문자 포함)",
  "validatorSixNumber": "6자리 숫자를 입력하세요.",
  "validatorFourMoreNumber": "4~32자리 숫자 또는 영문 조합으로 입력해주세요.",
  "validatorIpRule": "잘못된 IP 형식",
  "validatorChineseAndEnglish": "중국어 및 영어 전용, 범위 입력: 8-64자",
  "collectionSuccess": "즐겨찾기에 성공적으로 추가",
  "followedSuccess": "팔로우 성공",
  "cancelSuccess": "취소 성공",
  "evaluateOrder": "사진으로 검토",
  "evaluateOrderPlaceholder": "제품을 검토하십시오",
  "operationSuccess": "작업 성공",
  "confirmReceiveGoods": "상품수령확인 여부",
  "evaluateOrderSuccess": "검토 성공",
  "yesterday": "어제",
  "notLogin": "아직 로그인하지 않았습니다.",
  "delAllHistoryRecord": "모든 내역 기록을 삭제하시겠습니까?",
  "or": "또는",
  "tipsRemindsText": "판매자는 배송이 알림을 받은 후 알림을 받게 됩니다.",
  "tipsRemindsCount": "한 번만 상기시킬 수 있습니다.",
  "tipsRemindsMerchant": "판매자에게 알림",
  "tipsRemindsSuccess": "알림 성공",
  "noCartTips": "쇼핑백이 비어 있습니다. 쇼핑을 시작하세요.",
  "defaultRate": "시스템은 기본적으로 호의적인 리뷰로 설정됩니다.",
  "prevPage": "이전 페이지",
  "nextPage": "다음 페이지",
  "returnApply": "환불 요청",
  "returnReason": "환불사유",
  "returnAmount": "반환 금액",
  "returnRemark": "반품 안내",
  order: {
    cancel: "주문 취소",
    payment: "지금 지불하세요",
    remind: "배송 알림",
    return: "제품 환불 요청",
    evaluate: "지금 검토",
    logistics: "물류 보기",
    noRefund: "환불되지 않음",
    refunding: "환불 진행 중",
    refundSuccess: "환불 성공",
    refundFail: "환불 실패",
    confirm: "영수증 확인",
    expressCompany: '택배사',
    trackingNo: '운송장 번호',
    noOrderShipping: '배송 정보 없음',
    noTransitSteps: '배송 추적 정보 없음',
    logisticsLoadFail: '물류 정보를 불러오지 못했습니다. 나중에 다시 시도하세요.',
  },
  "remindTitle": "배송 알림",
  "remindContent": "배송 알림을 받은 후 판매자는 알림을 받게 됩니다. 한 번만 상기시킬 수 있습니다.",
  "remindSuccess": "알림 성공",
  "remindRepeat": "이 주문이 상기되었습니다.",
  "noComments": "현재 리뷰 없음",
  "storeSeach": "이 매장에서 제품 검색",
  "storeSeachTips1": "당신을 위해 찾았습니다",
  "storeSeachTips2": "관련 상점을 찾았습니다.",
  "storeSeachTips3": "집",
  "creditTit": "신용 서비스",
  "getCoupons": "더 많은 쿠폰 받기",
  "yourEmail": "귀하의 이메일 주소",
  "subscription": "구독",
  "paymethods": "지불 방법",
  "footdec": "{name} 글로벌 사이트 사용자는 전 세계 {num}개국에서 왔으며 {coin}를 사용하여 결제합니다. {coin}는 대기 및 국제 수수료 없이 전 세계에서 즉각적이고 저렴한 거래를 가능하게 하는 국경 없는 거래입니다.",
  "custService": "고객 서비스",
  "helpLine": "온라인 고객 서비스",
  "contactUs": "문의하기",
  "客户端下载": "클라이언트 다운로드",
  "提现方式": "지불 방법",
  "partner": "협력업체",
  "buyRules": "구매자 규칙",
  "sellerRules": "판매자 정책",
  "returnsAndEx": "반품 및 교환",
  "servicePolicy": "서비스 정책",
  "returnPolicy": "반품 정책",
  "user_Center": "사용자 센터",
  "userReg": "사용자 등록",
  "orderTrack": "주문 조회",
  "purchageHistory": "구매 내역",
  "myPurse": "내 지갑",
  "aboutUs": "회사 소개",
  "Recruitment": "인재를 기다립니다",
  "news": "뉴스 정보",
  "stateMent": "현대판 노예제 성명서",
  "binance": "바이낸스",
  "huobi": "후오비",
  "okx": "okx",
  "metaMask": "메타마스크",
  "homeBannertips1": "상인이 되십시오",
  "homeBannertips2": "총 수수료",
  "homeBannertips3": "최대",
  "homeBannerbtn": "지금 가입하세요",
  "homeDownloadtips1": "국경을 초월한 전자상거래 도매몰",
  "homeDownloadtips2": "브랜드 특별 행사",
  "homeDownloadtips3": "논스톱 할인",
  "homeDownloadtips4": "안드로이드 다운로드",
  "homeDownloadtips5": "애플 다운로드",
  "homeDownloadtips6": "QR 코드를 스캔하여 APP 다운로드",
  "homeIconTips1": "100% 정품",
  "homeIconTips2": "7일 반품",
  "homeIconTips3": "운임할인",
  "homeIconTips4": "보안 결제",
  "headerSearchTips": "검색할 키워드를 입력하세요",
  "collAccount": "대출 방식",
  "mine": "내 거.",
  "creditText1": "창업대출로 돈 빌리는 고민 해결",
  "creditText2": "창업자금 및 자본회전 서비스 제공",
  "creditWorry": "안심대출",
  "creditQuota": "유연한 한도",
  "creditQuotaINFO": "100,000 ~ 30,000,000 융통성 있는 한도 및 제한 없음, 최대 대출 기간 1년.",
  "quickLoan": "빠른 대출",
  "creditReview": "빠르면 1시간 안에 감사를 통과하고, 심사를 통과하면 바로 대출이 풀린다.",
  "safe": "안전하고 걱정 없는",
  "safeInfo": "모기지, 보증금, 콜백이 없습니다. 이것은 실제로 사적인 문제이기 때문입니다.",
  "about": "회사 소개",
  "aboutText1": "\"우리는 \"\"고객 우선\"\" 경영 철학을 바탕으로 대출 금융 서비스에 전념하고 있으며 고객 자본 회전율 문제를 해결한다는 사명을 가지고 있습니다. 설립 이래로 회사는 수많은 고객이 자본 회전율 문제를 해결하도록 도왔습니다.\"",
  "aboutText2": "한도: 100,000-30,000,000, 낮은 이율의 유연한 상환 방법, 선불 수수료 없음, 온라인 대출, 확인 전화 없음, 기밀 정보 및 당일 대출.",
  "contactUs1": "레벨메이트에게 돈을 빌리고 싶지 않다면 저희에게 연락주세요.",
  "committed": "기업 대출 서비스에 전념",
  "financial": "재정 문제 해결",
  "partnersTit": "파트너 온라인 대출 플랫폼",
  "application": "대출 지원서",
  "applicant": "응모자",
  "actualName": "실제 이름",
  "yourName": "이름을 입력하세요.",
  "term": "대출기간",
  "applicationAmount": "요청 금액",
  "rates": "대출 금리",
  "loanMethod": "대출 방식",
  "accountB": "계정 잔액",
  "countryOf": "국적",
  "myloan": "내 대출",
  "applyLoan": "대출 신청",
  "loaned": "대출",
  "interest": "이자 발생",
  "esRepayment": "예상 상환액",
  "loanHistory": "대출 기록",
  "applicantDate": "지원 날짜",
  "repayment": "반환",
  "cycle": "상환주기",
  "fixedRate": "고정금리",
  "successLoan": "대출 성공",
  "Reapply": "재신청",
  "borrow": "대출 실패",
  "applicantIn": "신청 진행 중",
  "repaid": "반환",
  "overdue": "연체",
  "estirepay": "예상 상환액",
  "loanDays": "대출일수",
  "reAmount": "상환 금액",
  "repay": "상환 방식",
  "entRepay": "상환 확인",
  "foryourmoney": "자금이 부족하거나 돈을 빌릴 곳을 찾지 못하거나 친구에게 돈을 빌리는 것이 부끄럽다면 저희에게 연락하십시오. 우리는 언제든지 귀하의 의심에 답할 수 있는 전문적인 서비스의 전 과정을 가지고 있습니다. 우리의 목표는 각 대출을 투명하게 만들어 고객이 빠르고 자신 있게 사용할 수 있도록 하는 것입니다.",
  "onlineApplin": "온라인으로 신청",
  "businessloan": "창업자금 신청",
  "selectCountry": "국적을 선택하세요.",
  "selectPeriod": "기간을 선택하세요.",
  "passPortImg": "주민등록번호/여권번호",
  "uploadId": "증명서 사진/여권 업로드",
  "readAndAgree": "읽었으며 동의합니다",
  "loanAgree": "대출 계약서",
  "submitApplica": "신청서 제출",
  "photoExample": "사진 촬영의 예",
  "discounted": "할인 상품",
  "days": "낮",
  "privacyPolicy": "개인 정보 정책",
  "delivery": "배송 및 픽업",
  "checkAgreement": "동의에 체크해주세요!",
  "businessPhone": "비즈니스 용 폰",
  "businessEmail": "기업 이메일",
  "充值金额不能小于1": "충전 금액은 1(소수점 둘째 자리 포함)보다 작을 수 없습니다.",
  "请切换其他语言后查看": "보려면 다른 언어로 전환하십시오",
  "我的购物车": "내 장바구니",
  "推荐商品": "추천 제품",
  "猜你喜欢": "당신이 그것을 좋아하는 것 같아요.",
  "暂无店铺": "매장을 찾을 수 없습니다.",
  "添加失败": "제출하지 못했습니다. 나중에 다시 시도 해주십시오",
  "提交订单": "주문 제출",
  recommendclass: "추천 분류",
  "滑动验证": "슬라이드 인증",
  "最多上传9张图片": "최대 9장의 사진을 업로드 할 수 있습니다.",
  "账号注销": "계정 취소",
  "确定注销": "취소 확인",
  "您的账号": "귀하의 계정",
  "为什么要离开": "왜 떠나야합니까?",
  "您还有余额,不能注销账号": "귀하의 잔액이 있으므로 계정을 취소 할 수 없습니다.",
  "请输入注销理由": "취소 사유를 입력하십시오.",
  "您确认要注销吗?": "귀하는 취소하시겠습니까?",
  "我再考虑下": "나는 다시 생각해 볼게",
  "同意注销": "동의 취소",
  "注销成功": "취소 성공",
  "App下载(买家端)": "App 다운로드 (구매자)",
  "App下载(卖家端)": "App 다운로드 (판매자)",
  "请选择": "선택해주세요",
  "提款地址绑定": "인출 주소 바인딩",
  "绑定成功": "바인딩 성공",
  "最多包含10位小数": "최대 10 자리 소수점",
  "企业电话": "기업 전화",
  "职业机会": "직장 기회",
  "仅能绑定一个收款地址!": "한 개의 수령 주소 만 바인딩 할 수 있습니다!",
  "长时间未付款，系统自动取消订单": "장시간 미지급, 시스템이 자동으로 주문을 취소합니다.",
  "加密货币": "암호화폐",
  "银行卡": "은행 카드",
  '参数缺失': "매개 변수가 누락되었습니다.",
  '充值数量必填': "충전 수량 필수",
  "充值币种": "충전 화폐",
  "充值金额": "충전 금액",
  "充值金额不得小于": "충전 금액은",
  "充值金额不得大于": "충전 금액은",
  "请先选择币种": "먼저 화폐를 선택하십시오.",
  "开户行": "개설 은행",
  "请输入开户行名称": "개설 은행 이름을 입력하십시오.",
  "银行卡号": "은행 카드 번호",
  "请输入银行卡号": "은행 카드 번호를 입력하십시오.",
  "点击去支付": "지불하러 가기",
  "企业证明": "기업 증명",
  footTipTikTok:' BizSpring 몰 ©️2024 저작권',
  "cancelInfo":"경고하다! 계정 해지 시 주의 부탁드리며, 더 이상 계정을 사용하지 않으실 경우 [해지 동의] 버튼을 클릭하시면 해지 후 수일이 지나면 가입이 불가능할 수 있습니다.",
  TikTokFoot:'BizSpring Mall은 글로벌 쇼트 비디오 소셜 플랫폼 BizSpring 과 아시아 최대 도매 무역 회사인 Alibaba가 협력하여 설립한 회사입니다. 글로벌 전자상거래 플랫폼으로 캐나다 토론토, 로스앤젤레스, 일본 치바에 위치한 세계 3개 자체 운영 스마트 창고를 보유하고 있다. 앱에서 판매되는 제품에는 일본, 한국, 중국 및 기타 아시아 국가의 인기 제품이 포함됩니다. 현재 총 수는 50,000개를 넘어섰고 계속해서 빠르게 성장하고 있습니다.'
  
,
  "getCouponSuccess": "쿠폰 수령 완료",
  "liveRooms": "라이브 룸",
  "liveStreaming": "라이브 중",
  "notStarted": "시작 전",
  "finished": "종료됨",
  "myPoints": "내 포인트",
  "searchGoods": "상품 검색",
  "points": "포인트",
  "point": "포인트",
  "stock": "재고",
  "spec": "사양",
  "exchangeNow": "지금 교환",
  "currentPoint": "내 포인트",
  "pointNotEnough": "포인트 부족"

,
    "contactInfo": "Contact Information",
    "consignee": "Full Name",
    "phone": "Phone",
    "enterName": "Enter full name",
    "enterPhone": "Enter phone number",
    "country": "Country",
    "province": "State/Province",
    "detailAddress": "Detail Address",
    "enterAddress": "Enter street address",
    "paymentInfo": "Payment Information",
    "cardNumber": "Card Number",
    "cardHolder": "Cardholder Name",
    "enterCardHolder": "Enter cardholder name",
    "expiryDate": "Expiry Date",
    "cardNumberRequired": "Card number is required",
    "cardHolderRequired": "Cardholder name is required",
    "expiryDateRequired": "Expiry date is required",
    "emailRegistered": "This email is already registered. You can login after checkout.",
    "nameRequired": "Name is required",
    "phoneRequired": "Phone is required",
    "countryRequired": "Country is required",
    "addressRequired": "Address is required",
    "cardExpired": "Card has expired",
    "registerFailed": "Registration failed",
    "accountExists": "Account already exists, please login to continue",
    "operationFailed": "Operation failed",
    "continueToCheckout": "Continue to Checkout",
    "emailRequired": "Email is required",
    "emailInvalid": "Invalid email format",
    "中文繁體": "繁體中文",
    "中文简体": "简体中文",
    "日本語": "日本語",
    "shoppingCart": "Shopping Cart",
    "selectAll": "Select All",
    "goodsName": "Product Name",
    "subtotal": "Subtotal",
    "action": "Action",
    "selected": "Selected",
    "total": "Total",
    "emptyCart": "Your shopping cart is empty",
    "allStores": "All Stores",
    "searchStore": "Search stores",
    "viewStore": "Visit Store",
    "streamEnded": "Stream Ended",
    "liveGoods": "Live Products",
    "announcements": "Announcements",
    "pointHistory": "Points History",
    "type": "Type",
    "remark": "Remark",
    "accountBind": "Account Binding",
    "mobileBind": "Mobile Binding",
    "notBound": "Not Bound",
    "change": "Change",
    "bind": "Bind",
    "emailBind": "Email Binding",
    "enterMobile": "Enter mobile number",
    "enterEmail": "Please enter email",
    "verifyCode": "Verification Code",
    "enterCode": "Enter verification code",
    "sendCode": "Send Code",
    "codeSent": "Code sent successfully",
    "bindSuccess": "Binding succeeded",
    "save": "Save",
    "saveSuccess": "Saved successfully",
    "balancePay": "Balance Pay",
    "wechatPay": "WeChat Pay",
    "alipay": "Alipay",
    "totalAmount": "Total Amount",
    "confirmPay": "Confirm Payment",
    "paySuccess": "Payment succeeded",
    "renew": "Renew",
    "vipPrivileges": "VIP Privileges",
    "growthValue": "Growth Value",
    "expiry": "Expiry",
    "pointLottery": "Points Lottery",
    "costPoints": "Cost Points",
    "startLottery": "Start Lottery",
    "congratulations": "Congratulations",
    "betterLuckNextTime": "Better luck next time",
    "noLottery": "No lottery available",
    "insufficientPoints": "Insufficient points",
    "pendingComment": "Pending Review",
    "commented": "Reviewed",
    "close": "Close",
    "loginFail": "Login failed",
    "paymentFailed": "Payment failed",
    "subscribe": "Subscribe",
    "confirmDelete": "Are you sure you want to delete?",
    "tips": "Tips",
    "deleteSuccess": "Deleted successfully",
    "KEY": "韩语(ko)",
    "addImageHint": "(이미지를 추가하세요)",
    "deleteNode": "삭제",
    "topPos": "상단 {n}",
    "col": "열 {n}",
    "pos": "위치 {n}",
    "decoType_container": "컨테이너",
    "decoType_title": "제목 텍스트",
    "decoType_richText": "리치 텍스트",
    "decoType_notice": "공지",
    "decoType_blank": "여백",
    "decoType_banner": "캐러셀",
    "decoType_imageSingle": "단일 이미지",
    "decoType_imageMulti": "다중 이미지",
    "decoType_video": "동영상",
    "decoType_goodsRecommend": "상품 추천",
    "decoType_goodsSelection": "상품 셀렉션",
    "decoType_seckill": "타임 세일",
    "decoType_groupBuy": "공동구매",
    "decoType_coupon": "쿠폰",
    "decoType_searchNav": "검색 내비",
    "decoType_search": "검색창",
    "decoType_searchBox": "검색창",
    "decoType_categoryNav": "카테고리 내비",
    "decoType_goodsCategory": "상품 카테고리",
    "decoType_navIconRow": "내비 아이콘",
    "decoType_imageScroll": "이미지 스크롤",
    "decoType_pageBanner": "페이지 배너",
    "decoType_tabs": "탭",
    "decoType_brand": "브랜드",
    "decoType_storeRecommend": "매장 추천",
    "decoType_hotSelection": "인기 셀렉션",
    "decoType_footerLinkGroup": "푸터 링크",
    "decoType_partnerLogoRow": "파트너",
    "decoType_icpInfo": "ICP 정보",
    "decoType_topNavMenu": "상단 내비",
    "decoType_logoBlock": "로고",
    "decoType_langSwitcher": "언어",
    "decoType_currencySwitcher": "통화",
    "decoType_loginBlock": "로그인",
    "decoType_cartIcon": "장바구니",
    "decoType_messageIcon": "메시지",
    "seckillPrice": "세일 가격",
    "seckillTag": "타임 세일",
    "seckillCountdown": "종료까지",
    "seckillNotStarted": "곧 시작",
    "seckillRushing": "진행 중",
    "seckillWillStart": "곧 시작",
    "seckillBuy": "바로 구매 (세일)",
    "groupPrice": "공동구매가",
    "groupRequiredNum": "명이 모이면 성사",
    "noGroupBuy": "단독 구매",
    "groupRule1": "1. 상품 선택",
    "groupRule2": "2. 공동구매 시작",
    "groupRule3": "3. 성사 후 배송",
    "marketingMoneyOff": "할인",
    "marketingFreeShipping": "무료배송",
    "marketingGift": "사은품",
    "marketingCoupon": "쿠폰",
    "marketingGroup": "공동구매",
    "marketingSeckill": "타임세일",
    "marketingExpired": "행사 종료",
    "marketingNotActive": "행사 미진행",
    "alreadyGotCoupon": "받음",
    "couponReceived": "받음",
    "hotSearch": "인기 검색:"
}